'use strict';

var _ = require('lodash');
var BookingsIntakeModalDataProviderService = function BookingsIntakeModalDataProviderService($q, dataRetrieverService, dataRetrieverConstantsService, featureToggleService, SearchCriteriaRule) {
  var POSITIVE_BAR_CLASS = ['positive-bar'];
  var NEGATIVE_BAR_CLASS = ['negative-bar'];
  var C = dataRetrieverConstantsService;
  var GRID_TO_MODE_MAPPING = {
    'cabin-flight-analysis': C.CABIN_BOOKINGS_INTAKE_MODE,
    'class-flight-analysis': C.SEGMENT_CLASS_BOOKINGS_INTAKE_MODE,
    'segment-flight-analysis': C.SEGMENT_CLASS_BOOKINGS_INTAKE_MODE,
    'market-demand-analysis': C.MARKET_BOOKINGS_INTAKE_MODE,
    'market-product-group-analysis': C.MARKET_PRODUCT_GROUP_BOOKINGS_INTAKE_MODE,
    'service-flight-analysis': C.SERVICE_BOOKINGS_INTAKE_MODE,
    'service-demand-analysis': C.SERVICE_BOOKINGS_INTAKE_MODE,
    'service-management': C.SERVICE_MANAGEMENT_BOOKINGS_INTAKE_MODE,
    'flight-summary': C.CABIN_BOOKINGS_INTAKE_MODE,
    'inventory-management': C.CLASS_BOOKINGS_INTAKE_MODE
  };
  function mapGridToMode(gridId) {
    return GRID_TO_MODE_MAPPING[gridId];
  }
  function getDataRetriever(screen, gridId) {
    return dataRetrieverService.getDataRetriever(screen, mapGridToMode(gridId), C.BOOKINGS_INTAKE_MODAL);
  }
  function getChartData(data) {
    return _.chain(data).filter(function (item) {
      return !_.isNil(item.offset) && !_.isNil(item.intake);
    }).map(function (item) {
      return {
        offsetDays: item.offset,
        data: [item.intake],
        circles: getDots(item),
        css: item.intake >= 0 ? POSITIVE_BAR_CLASS : NEGATIVE_BAR_CLASS
      };
    }).value();
  }
  function getDots(item) {
    var dots = [];
    if (!_.isNil(item.intakeLY)) {
      dots.push({
        value: item.intakeLY,
        css: 'dot'
      });
    }
    if (!_.isNil(item.intakeRY)) {
      dots.push({
        value: item.intakeRY,
        css: 'dot-dark'
      });
    }
    return dots;
  }
  function buildFlightRules(rowData) {
    return [new SearchCriteriaRule({
      field: 'flightId',
      leftOperand: rowData.flightId,
      operator: '='
    }), new SearchCriteriaRule({
      field: 'referenceCurveFlightId',
      leftOperand: rowData.referenceCurveFlightId,
      operator: '='
    })];
  }
  function buildServiceRules(rowData) {
    var serviceRules = [new SearchCriteriaRule({
      field: 'serviceId',
      leftOperand: rowData.serviceId,
      operator: '='
    })];
    if (rowData.referenceCurveServiceId) {
      serviceRules.push(new SearchCriteriaRule({
        field: 'referenceCurveServiceId',
        leftOperand: rowData.referenceCurveServiceId,
        operator: '='
      }));
    }
    return serviceRules;
  }
  function buildMarketRules(rowData) {
    return [new SearchCriteriaRule({
      field: 'marketDemandId',
      leftOperand: rowData.marketDemandId,
      operator: '='
    }), new SearchCriteriaRule({
      field: 'referenceCurveMarketDemandId',
      leftOperand: rowData.referenceCurveMarketDemandId,
      operator: '='
    })];
  }
  function buildSearchRules(gridId, rowData) {
    var MAPPED_MODE = featureToggleService.isEnabled('MAPPED_MODE');
    var mode = mapGridToMode(gridId);
    var rules = [];
    switch (mode) {
      case C.SERVICE_BOOKINGS_INTAKE_MODE:
        rules = buildServiceRules(rowData);
        rules.push(new SearchCriteriaRule({
          field: 'curveIds',
          leftOperand: rowData.serviceId + '_' + rowData.className + '_' + rowData.posName + '_' + (MAPPED_MODE ? 'REGULAR' : 'MAPPED'),
          operator: '='
        }));
        return rules;
      case C.SERVICE_MANAGEMENT_BOOKINGS_INTAKE_MODE:
        rules = buildServiceRules(rowData);
        rules.push(new SearchCriteriaRule({
          field: 'curveIds',
          leftOperand: rowData.spos + '_' + (MAPPED_MODE ? 'REGULAR' : 'MAPPED'),
          operator: '='
        }));
        return rules;
      case C.MARKET_BOOKINGS_INTAKE_MODE:
        rules = buildMarketRules(rowData);
        rules.push(new SearchCriteriaRule({
          field: 'curveIds',
          leftOperand: rowData.posName + '_' + (MAPPED_MODE ? 'REGULAR' : 'MAPPED'),
          operator: '='
        }));
        return rules;
      case C.MARKET_PRODUCT_GROUP_BOOKINGS_INTAKE_MODE:
        rules = buildMarketRules(rowData);
        rules.push(new SearchCriteriaRule({
          field: 'curveIds',
          leftOperand: rowData.classGroup + '_' + rowData.posName + '_' + (MAPPED_MODE ? 'REGULAR' : 'MAPPED'),
          operator: '='
        }));
        return rules;
      case C.CABIN_BOOKINGS_INTAKE_MODE:
        rules = buildFlightRules(rowData);
        rules.push(new SearchCriteriaRule({
          field: 'curveIds',
          leftOperand: rowData.legCabinId,
          operator: '='
        }));
        return rules;
      case C.CLASS_BOOKINGS_INTAKE_MODE:
      case C.SEGMENT_CLASS_BOOKINGS_INTAKE_MODE:
        rules = buildFlightRules(rowData);
        rules.push(new SearchCriteriaRule({
          field: 'curveIds',
          leftOperand: rowData.segmentClassId,
          operator: '='
        }));
        return rules;
      default:
        return [];
    }
  }
  function getData(screen, gridId, customDtd, rowData, bookingsCurrent, bookingsCurrentLY, bookingsCurrentRY) {
    var dataRetriever = getDataRetriever(screen, gridId);
    dataRetriever.defaultSortDefer = $q.all();
    dataRetriever.defaultSortCriteriaPromise = dataRetriever.defaultSortDefer.promise;
    dataRetriever.setCustomSearchCriteriaRules(buildSearchRules(gridId, rowData));
    dataRetriever.updateAdditionalParameters({
      bookingsCurrent: bookingsCurrent,
      bookingsCurrentLY: bookingsCurrentLY,
      bookingsCurrentRY: bookingsCurrentRY,
      daysToDeparture: rowData.daysToDeparture,
      customDtd: customDtd
    });
    return dataRetriever.retrieveComponentData(C.BOOKINGS_INTAKE_MODAL);
  }
  return {
    mapGridToMode: mapGridToMode,
    getDataRetriever: getDataRetriever,
    getChartData: getChartData,
    buildSearchRules: buildSearchRules,
    getData: getData
  };
};
BookingsIntakeModalDataProviderService.$inject = ['$q', 'DataRetrieverService', 'DataRetrieverConstantsService', 'FeatureToggleService', 'SearchCriteriaRuleFactory'];
module.exports = BookingsIntakeModalDataProviderService;